"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _utils = require("../../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UnbanOption = function UnbanOption(_ref) {
  var option = _ref.option,
    onBanSuccess = _ref.onBanSuccess,
    userId = _ref.userId,
    channelId = _ref.channelId,
    _ref$banTags = _ref.banTags,
    banTags = _ref$banTags === void 0 ? null : _ref$banTags;
  var _useRequest = (0, _utils.useRequest)(function (userId, channel) {
      return {
        url: (0, _utils.getUnbanUserUrl)(channel, userId),
        method: 'post'
      };
    }, {
      manual: true,
      onSuccess: onBanSuccess
    }),
    unbanUser = _useRequest.run,
    unbanningUser = _useRequest.loading;
  var onUnbanClick = function onUnbanClick(option) {
    if (option.action === _constants.BAN_ACTION_TYPES.FROM_ALL_PUBLIC_CHANNELS || option.action === _constants.BAN_ACTION_TYPES.FROM_CHANNEL) {
      unbanUser(userId, option.action === _constants.BAN_ACTION_TYPES.FROM_CHANNEL ? channelId : undefined);
    } else {
      console.error("action: ".concat(option.action, " is not supported"));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, banTags, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    style: {
      display: 'block'
    },
    onClick: function onClick() {
      onUnbanClick(option);
    },
    loading: unbanningUser
  }, option.label));
};
var _default = UnbanOption;
exports.default = _default;